module.exports = __webpack_public_path__ + "Roboto-LightItalic.129c5057f4480f9a353e.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-LightItalic.ttf
// module id = 385
// module chunks = 2